<template>
    <div id="topfrom">
        <!-- navbar navbar-default navbar-fixed-top container -->
        <nav class="box_fixed navbar navbar-fixed-top" id="boxFixed" :class="{ is_fixed: isFixed }">
            <img class="logoimg" src="../../static/images/zmlogo.png" />
            <div class="navtil">
                <el-dropdown placement>
                    <div @click="goindex" class="box_fixed2" id="boxFixed2">
                        首页
                        <!-- <span class="el-dropdown-link"> 首页</span> -->
                        <el-dropdown-menu slot="dropdown" :popper-append-to-body="true">
                            <el-dropdown-item class="span_color">
                                <router-link to="/index2">企业简介</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link to="/business">业务范围</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link to="/boutique">精品工程</router-link>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </div>
                </el-dropdown>
                <el-dropdown placement>
                    <div @click="goabout" class="box_fixed2" id="boxFixed2">
                        关于中明
                        <!-- <span class="el-dropdown-link"> 首页</span> -->
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <router-link :to="{ path: '/aboutus', query: { result: '0' } }">企业概况</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link :to="{ path: '/aboutus', query: { result: '1' } }">集团架构</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link :to="{ path: '/aboutus', query: { result: '2' } }">发展历程</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link :to="{ path: '/aboutus', query: { result: '3' } }">企业文化</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link :to="{ path: '/aboutus', query: { result: '4' } }">企业荣誉</router-link>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </div>
                </el-dropdown>
                <el-dropdown placement>
                    <div @click="gonewscenter" class="box_fixed2" id="boxFixed2">
                        新闻中心
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <router-link to="/newscenter">集团动态</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link to="/dynamics">业务动态</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link to="/videocenter">视频中心</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link to="/horizon">中明视界</router-link>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </div>
                </el-dropdown>
                <el-dropdown placement>
                    <div @click="goproduct" class="box_fixed2" id="boxFixed2">
                        服务领域
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <router-link :to="{ path: '/product', query: { result: '0' } }">建筑工程</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link :to="{ path: '/product', query: { result: '1' } }">规划设计</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link :to="{ path: '/product', query: { result: '2' } }">工程监理</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link :to="{ path: '/product', query: { result: '3' } }">EPC项目</router-link>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </div>
                </el-dropdown>
                <el-dropdown placement>
                    <div @click="gotechnological" class="box_fixed2" id="boxFixed2">
                        科技创新
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="toachievements">技术成果</span>
                                <!-- <router-link to="/technologicalsd">技术成果</router-link> -->
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="toassembly">装配式建造</span>
                                <!-- <router-link to="/technologicalConstruction">装配式建造</router-link> -->
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="togreenconstruction">绿色建造</span>
                                <!-- <router-link to="/greenconstruction">绿色建造</router-link> -->
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="tosmartsite">智慧工地</span>
                                <!-- <router-link to="/constructionsite">智慧工地</router-link> -->
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="todigitalization">信息数字化</span>
                                <!-- <router-link to="/pieceInformation">信息数字化</router-link> -->
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="tostandardization">项目标准化</span>
                                <!-- <router-link to="/projectStandardization">项目标准化</router-link> -->
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </div>
                </el-dropdown>

                <el-dropdown placement>
                    <div @click="gopartywork" class="box_fixed2" id="boxFixed2">
                        党群工作
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <router-link to="/partywork">党务工作</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link to="/tradunionwork">工会工作</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link to="/leagueaffairswork">团务工作</router-link>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <router-link to="/zhongmingwelfarebank">中明公益行</router-link>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </div>
                </el-dropdown>
                <el-dropdown placement>
                    <div @click="gocontact" class="box_fixed2" id="boxFixed2">
                        加盟中明
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item>
                                <span @click="toWholecountry">全国业务布局</span>
                                <!-- <router-link to="/Wholecountry">全国业务布局</router-link> -->
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="toBusinessCooperation">商务合作</span>
                                <!-- <router-link to="/businesscooperation">商务合作</router-link> -->
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <span @click="torecruittalents">招贤纳才</span>
                                <!-- <router-link to="/recruittalents">招贤纳才</router-link> -->
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </div>
                </el-dropdown>
                <!-- <el-dropdown placement>
                    <div class="box_fixed2" id="boxFixed2">
                        <a :href="msgs.zmColorLink" target="_blank" class="lastbox">中明云采</a>
                    </div>
                </el-dropdown> -->
                <!-- <div @click="/*gotalent*/">
                    <a :href="msgs.zmColorLink" target="_blank" class="box_fixed2 color_box lastbox" id="boxFixed2"
                        >中明云采</a
                    >
                </div> -->
                <!-- <div @click="/*gotalent*/">
                    <a
                        href="http://zmjt.zhong360.net/"
                        target="_blank"
                        class="box_fixed2 color_box lastbox"
                        id="boxFixed2"
                        >协同办公</a
                    >
                </div>
                <div @click="/*gotalent*/">
                    <a
                        href="http://zmjt.zhong360.net/"
                        target="_blank"
                        class="box_fixed2 color_box lastbox"
                        id="boxFixed2"
                        >登录后台</a
                    >
                </div> -->
            </div>
            <div class="rightbtn">
                <div style="margin-bottom: 10rem">
                    <a href="http://zmjt.zhong360.net/" target="_blank" id="boxFixed2">协同办公</a>
                </div>
                <div>
                    <a href="http://zhongmingjt.com/zmback" target="_blank" id="boxFixed2">登录后台</a>
                </div>
            </div>
            <div class="rgbtn" v-show="open" @click="toshow">
                <img src="../../static/images/menu.png" alt="" style="width: 100%; height: 100%" />
            </div>
            <div class="rgbtn" v-show="close" @click="toclose">
                <img src="../../static/images/menu_close.png" alt="" style="width: 73%; height: 70%; margin-top: 12%" />
            </div>
        </nav>
        <!-- <el-carousel height="970rem" class="caroul" indicator-position="outside" style="position:relative"> -->
        <el-carousel id="caroul" height="970rem" class="caroul" style="position: relative" trigger="click">
            <el-carousel-item v-for="(item, index) in baanerlist" :key="index">
                <el-image :src="item.address" style="width: 100%; height: 100%" fit="cover"> </el-image>
            </el-carousel-item>
        </el-carousel>
        <el-carousel id="caroul" height="332rem" class="caroul2" style="position: relative" trigger="click">
            <el-carousel-item v-for="(item, index) in baanerlist" :key="index">
                <el-image :src="item.address" style="width: 100%; height: 100%" fit="cover"> </el-image>
            </el-carousel-item>
        </el-carousel>

        <transition enter-active-class="kerwin-enter-active" leave-active-class="kerwin-leave-active">
            <div class="litnavbar" v-if="navbarshow">
                <div @click="goindex">首页</div>
                <div @click="goabout">关于中明</div>
                <div @click="gonewscenter">新闻中心</div>
                <div @click="goproduct">服务领域</div>
                <div @click="gotechnological">科技创新</div>
                <div @click="gopartywork">党群工作</div>
                <div @click="gocontact">加盟中明</div>
                <!-- <div @click="/*gotalent*/">
                    <a :href="msgs.zmColorLink" target="_blank">中明云采</a>
                </div> -->
            </div>
        </transition>
    </div>
</template>

<script>
import { getnewindex, getmsg } from '@/api/api';
// import { getmsg } from '@/api/api';
export default {
    data() {
        return {
            result: 0,
            // headerNav: [
            //     {
            //         name: '全国业务布局',
            //     },
            //     {
            //         name: '商务合作',
            //     },
            //     {
            //         name: '招贤纳才',
            //     },
            // ],
            golaburl: 'http://39.101.74.19:8717/base-admin',
            navbarshow: false,
            close: false,
            open: true,
            isFixed: false,
            offsetTop: 0,
            baanerlist: [],
            msgs: [],
            ascription: 'banner',
            page: 1,
            limit: 999,
            flag: false, //是否第一次打开
        };
    },
    watch: {
        $route(newValue) {
            if (newValue.path == '/details') {
                this.routing = false;
            } else {
                this.routing = true;
            }
            // 当页面路由变化 滑动到页面可视区
            // let height = 870
            let heightBanner = document.getElementById('caroul').offsetHeight;
            let topH = document.getElementById('boxFixed').offsetHeight;
            let height = heightBanner - topH;
            localStorage.setItem('scrollHeight', JSON.stringify(height));
            if (this.flag) {
                // window.scrollTo(0, 0);
                document.body.scrollTop = 0;
                // document.documentElement.scrollTop = 870;
                setTimeout(() => {
                    window.scrollTo(0, height);
                }, 300);
            } else if (
                navigator.userAgent.match(
                    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
                )
            ) {
                window.scrollTo(0, 0);
            } else {
                this.flag = true;
            }
        },
    },

    async mounted() {
        window.addEventListener('scroll', this.initHeight);
        this.$nextTick(() => {
            //获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置
            this.offsetTop = document.querySelector('#boxFixed').offsetTop;
            document.getElementById('boxFixed2').scrollIntoView({ behavior: 'smooth' });
        });
        await this.getbaaner();
        await this.getmsg();
    },
    methods: {
        // 获取banner数据
        async getbaaner() {
            // // //
            const res = await getnewindex(this.ascription, this.page, this.limit);
            // // //
            if (res.code == 200) {
                this.baanerlist = res.data;
            }
        },
        // 获取数据
        async getmsg() {
            const res = await getmsg();
            if (res.code == 200) {
                this.msgs = res.data[0];
                // //
            }
        },
        toshow() {
            this.navbarshow = true;
            this.open = false;
            this.close = true;
        },
        toclose() {
            this.navbarshow = false;
            this.open = true;
            this.close = false;
        },
        toWholecountry() {
            this.$router.push({
                path: '/contact',
                query: {
                    result: '0',
                },
            });
        },
        toBusinessCooperation() {
            this.$router.push({
                path: '/contact',
                query: {
                    result: '1',
                },
            });
        },
        torecruittalents() {
            this.$router.push({
                path: '/contact',
                query: {
                    result: '2',
                },
            });
        },
        toachievements() {
            this.$router.push({
                path: '/technological',
                query: {
                    result: '0',
                },
            });
        },
        toassembly() {
            this.$router.push({
                path: '/technological',
                query: {
                    result: '1',
                },
            });
        },
        togreenconstruction() {
            this.$router.push({
                path: '/technological',
                query: {
                    result: '2',
                },
            });
        },
        tosmartsite() {
            this.$router.push({
                path: '/technological',
                query: {
                    result: '3',
                },
            });
        },
        todigitalization() {
            this.$router.push({
                path: '/technological',
                query: {
                    result: '4',
                },
            });
        },
        tostandardization() {
            this.$router.push({
                path: '/technological',
                query: {
                    result: '5',
                },
            });
        },
        gocontact() {
            this.navbarshow = false;
            this.open = true;
            this.close = false;
            this.$router.push({
                // path: '/Wholecountry',
                path: '/contact',
                query: {
                    result: '0',
                },
            });
        },
        gonewscenter() {
            this.navbarshow = false;
            this.open = true;
            this.close = false;
            // this.$router.push('/newscenter');
            this.$router.push({ path: '/newscenter' });
        },
        goindex() {
            this.navbarshow = false;
            this.open = true;
            this.close = false;
            this.$router.push({ path: '/index2' });
            // document.body.scrollIntoView({ behavior: 'smooth' });
        },
        goabout() {
            this.navbarshow = false;
            this.open = true;
            this.close = false;
            this.$router.push({ path: '/aboutus', query: { result: '0' } });
            // this.$router.push('/aboutus');
        },
        goproduct() {
            this.navbarshow = false;
            this.open = true;
            this.close = false;
            // this.$router.push('/product');
            this.$router.push({ path: '/product', query: { result: '0' } });
        },
        gotechnological() {
            this.navbarshow = false;
            this.open = true;
            this.close = false;
            this.$router.push({
                path: '/technological',
                query: {
                    result: '0',
                },
            });
            // this.$router.push('/technologicalsd');
        },
        gopartywork() {
            this.navbarshow = false;
            this.open = true;
            this.close = false;
            this.$router.push({ path: '/partywork' });
        },
        gotalent() {
            this.navbarshow = false;
            this.open = true;
            this.close = false;
            this.$router.push('/talent');
        },
        initHeight() {
            // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            //如果被卷曲的高度大于吸顶元素到顶端位置 的距离
            this.isFixed = scrollTop > this.offsetTop ? true : false;
        },
        Navclick(index) {
            this.result = index;
        },
    },
    //回调中移除监听
    // destroyed() {
    //   window.removeEventListener("scroll", this.handleScroll);
    // },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1280px) {
    .navtil div {
        width: 140rem !important;
    }
}
.caroul2 {
    display: none;
}
.rightbtn {
    position: absolute;
    color: white !important;
    font-size: 16rem;
    right: 46rem;
}
.rightbtn a {
    color: white !important;
}
.rightbtn a:hover {
    color: white !important;
}
// @media screen and (max-width: 2560rem) {
//     .fot_pic a {
//         font-size: 12rem !important;
//     }
// }
// @media screen and (max-width: 1400rem) {
//     .box_fixed .logoimg {
//         width: 204rem !important;
//         height: 54rem !important;
//         position: absolute !important;
//         top: 18% !important;
//         left: 4% !important;
//     }
//     .caroul2 {
//         margin-top: 200rem;
//         display: block;
//     }
//     .caroul {
//         display: none;
//     }
//     .box_fixed .logoimg {
//         width: 216rem !important;
//         height: 54rem !important;
//     }
//     .box_fixed {
//         height: 99rem !important;
//         background: #0e6eb8 !important;
//     }
// }
>>> .lastbox:hover {
    color: #e0e9f4;
    animation: animate 1s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    animation-play-state: running;
}
@keyframes animate {
    0%,
    40%,
    100% {
        transform: translateY(-1rem);
    }

    10% {
        transform: translateY(-1rem);
    }
}
a {
    color: #656565;
}
a:hover {
    color: #66b1ff !important;
    text-decoration: none;
}

.kerwin-enter-active {
    animation: aaa 0.5s;
}

.kerwin-leave-active {
    animation: aaa 0.5s reverse;
}

/* 定义动画的名字和开始到结束的样式 */
@keyframes aaa {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes ambg {
    0% {
        border: 4rem solid rgba(0, 0, 0, 0);
    }

    100% {
        // border-top: 4rem solid #004a9a;
    }
}

.litnavbar {
    // width: 100%;
    // height: 100%;
    // position: fixed;
    // top: 200rem;
    // z-index: 999;
    // color: #000;
    // display: flex;
    // flex-direction: column;
    // align-items: flex-start;
    // transition: 0.5s ease-in-out;
    // padding: 60rem 0 0 60rem;
    // background: #fff;

    // width: 200rem;
    width: 30%;
    height: 45%;
    position: fixed;
    top: 200rem;
    right: 0;
    z-index: 999;
    color: #fff !important;
    display: flex;
    align-items: flex-end;
    transition: 0.5s ease-in-out;
    // padding: 60rem 0 0 60rem;
    padding: 35rem;
    background: #0e6eb8;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    line-height: 75rem;
    // display: none;
    div {
        height: 200rem;
        font-size: 34rem;
    }
    div a:last-child {
        color: #fff !important;
    }
}

.navtil {
    width: 50%;
    display: flex;
    justify-content: space-around;
    height: 100%;
    margin-left: 242rem;

    div {
        width: 72rem;
        // height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16rem;
        border: 2rem solid rgba(0, 0, 0, 0);
        cursor: pointer;
        box-sizing: border-box;

        &:hover {
            animation: ambg 1.5s;
            border-bottom: 4rem solid #ffffff !important;
        }
    }
}

.box_fixed {
    width: 100%;
    height: 106rem;
    position: fixed;
    top: 0;
    z-index: 999;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.5s ease-in-out;
    justify-content: space-evenly;

    &:hover {
        background-color: #0e6eb8;
    }

    // &:hover {
    //     // background: #fff;
    //     // color: #000;
    // }
    .logoimg {
        width: 204rem;
        height: 54rem;
        position: absolute;
        top: 33rem;
        left: 204rem;
    }

    .rgbtn {
        // width: 150rem;
        width: 7%;
        font-size: 43rem;
        height: 150rem;
        // background: #000;
        display: none;
        position: absolute;
        right: 50rem;
        top: 25rem;
    }
    .rgbtn2 {
        // width: 150rem;
        width: 7%;
        font-size: 43rem;
        height: 150rem;
        // background: #000;
        display: none;
        position: absolute;
        right: 50rem;
        top: 25rem;
    }
}
.color_box:hover {
    color: #fff !important;
}

// 头部下拉框
>>> .box_fixed2 .span_color:hover {
    color: #66b1ff;
}
>>> .box_fixed2:hover {
    animation: animate 2s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    animation-play-state: running;
}

.box_fixed2 {
    // width: 100%;
    height: 106rem;
    position: fixed;
    top: 0;
    z-index: 999;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.5s ease-in-out;

    // &:hover {
    //     // background: #fff;
    //     // color: #000;
    // }
    // .logoimg {
    //     width: 204rem;
    //     height: 54rem;
    //     position: absolute;
    //     top: 33rem;
    //     left: 204rem;
    // }
    .rgbtn {
        width: 150rem;
        height: 150rem;
        background: #000;
        display: none;
        position: absolute;
        right: 50rem;
        top: 25rem;
    }
}

// 轮播图自带
>>> [data-v-29ad591f] .el-carousel__indicators--outside {
    bottom: 26rem;
    text-align: center;
    -webkit-transform: none;
    transform: none;
    border-radius: 50%;
    position: absolute;
    bottom: 20rem;
    left: 50%;
    width: 96rem;
    height: 16rem;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    transform: translate(-50%, -50%);
}

:deep() .el-carousel__button {
    display: block;
    // width: 30rem;
    // height: 2rem;
    background-color: #fff;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    width: 16rem;
    height: 16rem;
    /* background: #FFFFFF; */
    border-radius: 50%;
}
>>> .el-carousel__indicator.is-active button {
    opacity: 1;
    display: block;
    // opacity: 0.48;
    width: 16rem;
    height: 16rem;
    border-radius: 50%;
    background-color: #fff;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    -webkit-transition: 0.3s;
    transition: 0.3s;
}
>>> .el-dropdown-menu__item {
    list-style: none;
    line-height: 36rem;
    padding: 0 10rem;
    /* margin: 0 20rem; */
    font-size: 16rem;
    color: #606266;
    cursor: pointer;
    /* outline: 0; */
}
>>> .el-carousel__indicator--horizontal {
    display: inline-block;
    padding: 12rem 12rem;
}
// 下拉菜单

>>> [data-v-29ad591f1] .el-dropdown-menu item:not(.is-disabled):hover {
    color: #66b1ff !important;
}

>>> .el-dropdown-menu {
    position: absolute;
    text-align: center;
    top: 0;
    left: 0;
    z-index: 10;
    padding: 10rem 0;
    /* margin: 5rem 0; */
    background-color: #fff;
    border: 1rem solid #ebeef5;
    border-radius: 4rem;
    // -webkit-box-shadow: 0 2rem 12rem 0 rgb(0 0 0 / 10%);
    box-shadow: 0 2rem 12rem 0rgba (0, 0, 0, 0.1);
}

.is_fixed {
    // background: #fff;
    // background: transparent;
    background: #0e6eb8;
    // color: #000;
    color: #fff;
}

>>> .navbar-inverse {
    // background-color: #222;
    border-color: #ffffff00;
}
// @media screen and (max-width: 800rem) {
//     .navtil {
//         display: none;

//         &::after {
//             display: block;
//             height: 0;
//             clear: both;
//             visibility: hidden;
//             overflow: hidden;
//             content: '.';
//         }
//     }

//     .box_fixed {
//         height: 200rem;
//         // background: #fff;
//         background: #0e6eb8;

//         .logoimg {
//             // width: 450rem;
//             // height: 200rem;
//             width: 410rem;
//             height: 123rem;
//         }

//         .rgbtn {
//             display: block;
//         }
//     }

//     .caroul {
//         margin-top: 200rem;
//     }
// }
// @media screen and (max-width: 980rem) {
//     .navtil {
//         display: none;

//         &::after {
//             display: block;
//             height: 0;
//             clear: both;
//             visibility: hidden;
//             overflow: hidden;
//             content: '.';
//         }
//     }

//     .box_fixed {
//         height: 200rem;
//         // background: #fff;
//         background: #0e6eb8;

//         .logoimg {
//             // width: 450rem;
//             // height: 200rem;
//             width: 410rem;
//             height: 123rem;
//         }

//         .rgbtn {
//             display: block;
//         }
//     }

//     .caroul {
//         margin-top: 200rem;
//     }
// }
// @media screen and (max-width: 1024rem) {
//     .navtil {
//         display: none;

//         &::after {
//             display: block;
//             height: 0;
//             clear: both;
//             visibility: hidden;
//             overflow: hidden;
//             content: '.';
//         }
//     }

//     .box_fixed {
//         height: 200rem;
//         // background: #fff;
//         background: #0e6eb8;

//         .logoimg {
//             // width: 450rem;
//             // height: 200rem;
//             width: 410rem;
//             height: 123rem;
//         }

//         .rgbtn {
//             display: block;
//         }
//     }

//     .caroul {
//         margin-top: 200rem;
//     }
// }
// @media screen and (max-width: 1400rem) {
//     .box_fixed .rgbtn {
//         display: block;
//         margin-right: 1% !important;
//     }
// }
// @media screen and (max-width: 1200rem) {
//     .navtil {
//         display: none;

//         &::after {
//             display: block;
//             height: 0;
//             clear: both;
//             visibility: hidden;
//             overflow: hidden;
//             content: '.';
//         }
//     }

//     .box_fixed {
//         height: 200rem;
//         // background: #fff;
//         background: #0e6eb8;

//         .logoimg {
//             // width: 450rem;
//             // height: 200rem;
//             width: 410rem;
//             height: 123rem;
//         }

//         .rgbtn {
//             display: block;
//         }
//     }

//     .caroul {
//         margin-top: 200rem;
//     }
// }
//
</style>
// <style lang="scss" scoped>
// .caroul2 {
//     display: none;
// }
// @media screen and (max-width: 1400rem) {
//     .box_fixed .logoimg {
//         width: 204rem !important;
//         height: 54rem !important;
//         position: absolute !important;
//         top: 18% !important;
//         left: 4% !important;
//     }
//     .caroul2 {
//         margin-top: 200rem;
//         display: block;
//     }
//     .caroul {
//         display: none;
//     }
//     .box_fixed .logoimg {
//         width: 216rem !important;
//         height: 54rem !important;
//     }
//     .box_fixed {
//         height: 99rem !important;
//         background: #0e6eb8 !important;
//     }
// }
>>> .lastbox:hover {
    color: #e0e9f4;
    animation: animate 1s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    animation-play-state: running;
}
@keyframes animate {
    0%,
    40%,
    100% {
        transform: translateY(-1rem);
    }

    10% {
        transform: translateY(-1rem);
    }
}
a {
    color: #656565;
}
a:hover {
    color: #66b1ff !important;
    text-decoration: none;
}

.kerwin-enter-active {
    animation: aaa 0.5s;
}

.kerwin-leave-active {
    animation: aaa 0.5s reverse;
}

/* 定义动画的名字和开始到结束的样式 */
@keyframes aaa {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes ambg {
    0% {
        border: 4rem solid rgba(0, 0, 0, 0);
    }

    100% {
        // border-top: 4rem solid #004a9a;
    }
}

.litnavbar {
    // width: 100%;
    // height: 100%;
    // position: fixed;
    // top: 200rem;
    // z-index: 999;
    // color: #000;
    // display: flex;
    // flex-direction: column;
    // align-items: flex-start;
    // transition: 0.5s ease-in-out;
    // padding: 60rem 0 0 60rem;
    // background: #fff;

    // width: 200rem;
    width: 30%;
    // height: 45%;
    position: fixed;
    top: 200rem;
    right: 0;
    z-index: 999;
    color: #fff !important;
    display: flex;
    align-items: flex-end;
    transition: 0.5s ease-in-out;
    // padding: 60rem 0 0 60rem;
    padding: 35rem;
    background: #0e6eb8;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    line-height: 75rem;
    // display: none;
    div {
        height: 200rem;
        font-size: 34rem;
    }
    div a:last-child {
        color: #fff !important;
    }
}

.navtil {
    width: 50%;
    display: flex;
    justify-content: space-around;
    height: 100%;
    margin-left: 242rem;

    div {
        width: 100rem;
        // height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16rem;
        border: 2rem solid rgba(0, 0, 0, 0);
        cursor: pointer;
        box-sizing: border-box;

        &:hover {
            animation: ambg 1.5s;
            border-bottom: 4rem solid #ffffff !important;
        }
    }
}

.box_fixed {
    width: 100%;
    height: 106rem;
    position: fixed;
    top: 0;
    z-index: 999;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.5s ease-in-out;
    justify-content: space-evenly;

    &:hover {
        background-color: #0e6eb8;
    }

    // &:hover {
    //     // background: #fff;
    //     // color: #000;
    // }
    .logoimg {
        width: 204rem;
        height: 54rem;
        position: absolute;
        top: 33rem;
        left: 204rem;
    }

    .rgbtn {
        // width: 150rem;
        width: 7%;
        font-size: 43rem;
        height: 150rem;
        // background: #000;
        display: none;
        position: absolute;
        right: 50rem;
        top: 25rem;
    }
    .rgbtn2 {
        // width: 150rem;
        width: 7%;
        font-size: 43rem;
        height: 150rem;
        // background: #000;
        display: none;
        position: absolute;
        right: 50rem;
        top: 25rem;
    }
}
.color_box:hover {
    color: #fff !important;
}

// 头部下拉框
>>> .box_fixed2 .span_color:hover {
    color: #66b1ff;
}
>>> .box_fixed2:hover {
    animation: animate 2s ease-in-out infinite;
    animation-delay: calc(0.1s * var(--i));
    animation-play-state: running;
}

.box_fixed2 {
    // width: 100%;
    height: 106rem;
    position: fixed;
    top: 0;
    z-index: 999;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.5s ease-in-out;

    // &:hover {
    //     // background: #fff;
    //     // color: #000;
    // }
    // .logoimg {
    //     width: 204rem;
    //     height: 54rem;
    //     position: absolute;
    //     top: 33rem;
    //     left: 204rem;
    // }
    .rgbtn {
        width: 150rem;
        height: 150rem;
        background: #000;
        display: none;
        position: absolute;
        right: 50rem;
        top: 25rem;
    }
}

// 轮播图自带
>>> [data-v-29ad591f] .el-carousel__indicators--outside {
    bottom: 26rem;
    text-align: center;
    -webkit-transform: none;
    transform: none;
    border-radius: 50%;
    position: absolute;
    bottom: 20rem;
    left: 50%;
    width: 96rem;
    height: 16rem;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    transform: translate(-50%, -50%);
}

>>> .el-carousel__button {
    display: block;
    // width: 30rem;
    // height: 2rem;
    background-color: #fff;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    width: 16rem;
    height: 16rem;
    /* background: #FFFFFF; */
    border-radius: 50%;
}
>>> .el-carousel__indicator.is-active button {
    opacity: 1;
    display: block;
    // opacity: 0.48;
    width: 16rem;
    height: 16rem;
    border-radius: 50%;
    background-color: #fff;
    border: none;
    outline: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
    -webkit-transition: 0.3s;
    transition: 0.3s;
}
>>> .el-dropdown-menu__item {
    list-style: none;
    line-height: 36rem;
    padding: 0 10rem;
    /* margin: 0 20rem; */
    font-size: 16rem;
    color: #606266;
    cursor: pointer;
    /* outline: 0; */
}
>>> .el-carousel__indicator--horizontal {
    display: inline-block;
    padding: 12rem 12rem;
}
// 下拉菜单

>>> [data-v-29ad591f1] .el-dropdown-menu item:not(.is-disabled):hover {
    color: #66b1ff !important;
}

>>> .el-dropdown-menu {
    position: absolute;
    text-align: center;
    top: 0;
    left: 0;
    z-index: 10;
    padding: 10rem 0;
    /* margin: 5rem 0; */
    background-color: #fff;
    border: 1rem solid #ebeef5;
    border-radius: 4rem;
    // -webkit-box-shadow: 0 2rem 12rem 0 rgb(0 0 0 / 10%);
    box-shadow: 0 2rem 12rem 0rgba (0, 0, 0, 0.1);
}

.is_fixed {
    // background: #fff;
    // background: transparent;
    background: #0e6eb8;
    // color: #000;
    color: #fff;
}

>>> .navbar-inverse {
    // background-color: #222;
    border-color: #ffffff00;
}
// @media screen and (max-width: 800rem) {
//     .navtil {
//         display: none;

//         &::after {
//             display: block;
//             height: 0;
//             clear: both;
//             visibility: hidden;
//             overflow: hidden;
//             content: '.';
//         }
//     }

//     .box_fixed {
//         height: 200rem;
//         // background: #fff;
//         background: #0e6eb8;

//         .logoimg {
//             // width: 450rem;
//             // height: 200rem;
//             width: 410rem;
//             height: 123rem;
//         }

//         .rgbtn {
//             display: block;
//         }
//     }

//     .caroul {
//         margin-top: 200rem;
//     }
// }
// @media screen and (max-width: 980rem) {
//     .navtil {
//         display: none;

//         &::after {
//             display: block;
//             height: 0;
//             clear: both;
//             visibility: hidden;
//             overflow: hidden;
//             content: '.';
//         }
//     }

//     .box_fixed {
//         height: 200rem;
//         // background: #fff;
//         background: #0e6eb8;

//         .logoimg {
//             // width: 450rem;
//             // height: 200rem;
//             width: 410rem;
//             height: 123rem;
//         }

//         .rgbtn {
//             display: block;
//         }
//     }

//     .caroul {
//         margin-top: 200rem;
//     }
// }
// @media screen and (max-width: 1024rem) {
//     .navtil {
//         display: none;

//         &::after {
//             display: block;
//             height: 0;
//             clear: both;
//             visibility: hidden;
//             overflow: hidden;
//             content: '.';
//         }
//     }

//     .box_fixed {
//         height: 200rem;
//         // background: #fff;
//         background: #0e6eb8;

//         .logoimg {
//             // width: 450rem;
//             // height: 200rem;
//             width: 410rem;
//             height: 123rem;
//         }

//         .rgbtn {
//             display: block;
//         }
//     }

//     .caroul {
//         margin-top: 200rem;
//     }
// }
// @media screen and (max-width: 1400rem) {
//     .box_fixed .rgbtn {
//         display: block;
//         margin-right: 1% !important;
//     }
// }
// @media screen and (max-width: 1200rem) {
//     .navtil {
//         display: none;

//         &::after {
//             display: block;
//             height: 0;
//             clear: both;
//             visibility: hidden;
//             overflow: hidden;
//             content: '.';
//         }
//     }

//     .box_fixed {
//         height: 200rem;
//         // background: #fff;
//         background: #0e6eb8;

//         .logoimg {
//             // width: 450rem;
//             // height: 200rem;
//             width: 410rem;
//             height: 123rem;
//         }

//         .rgbtn {
//             display: block;
//         }
//     }

//     .caroul {
//         margin-top: 200rem;
//     }
// }
</style>



// WEBPACK FOOTER //
// src/components/topfrom.vue